<template>
<div class="business__request">
    
    <img class="business__request-logo" src="/img/Logo/blue.png" alt="Bonplan">
    <h3 class="business__request-title text-center">{{title}}</h3>
    <div v-if="subtitle" class="business__request-subtitle">{{subtitle}}</div>
    <div class="business__request-required-fields">* {{t.required_fields}}</div>
    
    <div class="business__request-form">
        <form :action="url" method="post" enctype="multipart/form-data" @submit="onSubmit">
            <input type="hidden" :name="csrf_token_name" :value="csrf_token_value" />
            <div class="form-group row">
                <label for="requestform-first-name" class="col-sm-4 col-form-label required">{{t.full_name}}</label>
                <div class="col-sm-6">
                    <input type="text" class="form-control" name="name" v-model="formData.name"
                        id="requestform-first-name">
                    <div v-if="!$v.formData.name.required && $v.formData.name.$error" class="form-text text-danger">
                        {{t.e_required}}</div>
                </div>
            </div>
            <div class="form-group row">
                <label for="requestform-phone" class="col-sm-4 col-form-label required">{{t.phone}}</label>
                <div class="col-sm-6">
                    <input type="text" class="form-control" name="phone" v-model="formData.phone"
                        id="requestform-phone">
                    <div v-if="!$v.formData.phone.required && $v.formData.phone.$error" class="form-text text-danger">
                        {{t.e_required}}</div>
                </div>
            </div>
            <div class="form-group row">
                <label for="requestform-email" class="col-sm-4 col-form-label required">{{t.email}}</label>
                <div class="col-sm-6">
                    <input type="text" class="form-control" name="email" v-model="formData.email"
                        id="requestform-email">
                    <div v-if="!$v.formData.email.required && $v.formData.email.$error" class="form-text text-danger">
                        {{t.e_required}}</div>
                    <div v-if="$v.formData.email.required && !$v.formData.email.email && $v.formData.email.$error"
                        class="form-text text-danger">{{t.e_email_format}}</div>
                </div>
            </div>
            <div class="form-group row">
                <label for="requestform-url" class="col-sm-4 col-form-label">{{t.website_if_exists}}</label>
                <div class="col-sm-6">
                    <input type="text" class="form-control" name="url" v-model="formData.url" id="requestform-url">
                </div>
            </div>
            <div class="form-group row">
                <label for="contactsform-message" class="col-sm-4 col-form-label required">{{t.message}}</label>
                <div class="col-sm-6">
                    <textarea id="contactsform-message" name="message" v-model="formData.message" class="form-control"
                        rows="5"></textarea>
                    <div v-if="!$v.formData.message.required && $v.formData.message.$error"
                        class="form-text text-danger">{{t.e_required}}</div>
                </div>
            </div>
            <div class="form-group row mb-2">
                <label class="col-sm-4 col-form-label">{{t.attachment}}</label>
                <div class="col-sm-6">
                    <div class="input-group-file">
                        <div class="btn business__request-form-attach-btn btn-outline-stroke-primary input-file-btn">
                            <input type="file" name="attachment" @change="onAttach" ref="attachment" class="custom-file-input" id="requestform-attachment">
                            {{t.select_file}}
                        </div>
                        <div class="input-file-chosen">{{formData.attachment && formData.attachment.name.split('\\').pop()}}</div>
                    </div>
                </div>
            </div>
            <div class="form-group row mb-3">
                <div class="col-sm-6 offset-sm-4">
                    <small class="form-text" v-bind:class="{
                    'text-muted': $v.formData.attachment.fileSize || !$v.formData.attachment.$error, 
                    'text-danger': !$v.formData.attachment.fileSize && $v.formData.attachment.$error
                }">{{t.select_file_limits}}</small>
                </div>
            </div>
            <div class="form-group row mb-3">
                <div class="col-sm-6 offset-sm-4">
                    <label class="form-check form-check-label business__request-form-agree-label">
                        <input type="checkbox" class="form-check-input" name="agree" v-model="formData.agree" value="1">
                        <span v-html="t.agreement_privacy"></span>
                    </label>
                    <div v-if="!$v.formData.agree.required && $v.formData.agree.$error" class="form-text text-danger">{{t.e_agree_privacy}}</div>
                </div>
            </div>
            <div class="form-group form-group-submit row">
                <div class="col-sm-6 offset-sm-4">
                    <button class="btn btn-shadow-primary btn-block" type="submit">{{t.send_request}}</button>
                </div>
            </div>
        </form>
    </div>
</div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators';
import { fileSize } from '../common/validators';

export default {
    data() {
        return {
            formData: {
                message: this.t.message_default,
                attachment: null
            },
            // formError: false,
            formErrors: {},
            loading: false,
        };
    },
    validations: {
        formData: {
            name: {
                required,
            },
            phone: {
                required,
            },
            email: {
                required,
                email,
            },
            url: {

            },
            message: {
                required,
            },
            attachment: {
                filesize: fileSize(10 * 1024 * 1024),
            },
            agree: {
                true: value => !!value,
            },
        },
    },
	methods: {
		formValidate() {
			this.formErrors = {};
            this.$v.formData.$touch();
            return !this.$v.$invalid;
        },
        onSubmit(event) {
            if (this.formValidate()) {
                // this.sendData();
            } else {
                event.preventDefault();
            }
        },
        // sendData() {
        //     this.loading = true;
        //     $.ajax({
        //         url: this.url,
        //         data: toFormData(this.formData),
        //         type: 'post',
        //         dataType: 'json',
        //         success: function (data) {
        //             if (data.success) {
        //                 window.location.reload();
        //             } else {
        //                 this.loading = false;
        //                 // this.formError = true;
        //                 this.formErrors = data.errors;
        //             }
        //         }.bind(this)
        //     });
        // },
        onAttach(event) {
            this.formData.attachment = event.target.files[0];
        }
	},
    computed: {
        csrf_token_name() {
            return $('meta[name="csrf-token-name"]').attr('content');
        },
        csrf_token_value() {
            return $('meta[name="csrf-token-value"]').attr('content');
        }
    },
    props: {
        t: Object,
        url: String,
        subtitle: String,
        title: {
            type: String,
            default() { return this.t.h_business_request; }
        }
    },
}
</script>

<style>
    
</style>